/**
 * Funnel Tracking System - Main Export
 * 
 * Centralized export for all funnel-related functionality
 */

// Type exports
export * from '@/types/funnel';

// Utility exports
export * from './utils';

// Re-export commonly used types for convenience
export type {
  FunnelCollection,
  FunnelCollectionV2,
  FunnelCollectionType,
  MunicipalityFunnel,
  SocialMediaFunnel,
  EmailFunnel,
  EnhancedMunicipalityFunnel,
  EnhancedSocialMediaFunnel,
  EnhancedEmailFunnel,
  FunnelEvent,
  FunnelSession,
  SessionMetrics,
  FunnelStep,
  FunnelConfig,
  FunnelIdPattern,
  BusinessType,
  ServiceType,
  GewerbeFunnelSession,
  TeilnehmerFunnelSession
} from '@/types/funnel';

// Re-export commonly used utilities
export {
  generateUUID,
  anonymizeIP,
  getCurrentTimestamp,
  createInitialFunnelCollection,
  createInitialFunnelCollectionV2,
  createMunicipalityFunnel,
  createSocialMediaFunnel,
  createEmailFunnel,
  createEnhancedMunicipalityFunnel,
  createEnhancedSocialMediaFunnel,
  createEnhancedEmailFunnel,
  createFunnelEvent,
  calculateSessionMetrics,
  getDeviceType,
  getViewportDimensions,
  validateFunnelEvent,
  shouldCleanupSession,
  shouldAnonymizeSession,
  isSessionTimedOut,
  getSessionStatus,
  extractUTMParameters,
  generateFunnelId,
  parseFunnelId,
  isFunnelCollectionV2,
  migrateSessionToV2,
  getCollectionType,
  isValidFunnelIdPattern
} from './utils';

// Constants
export const FUNNEL_COLLECTION_KEY = 'funnels:json';
export const FUNNEL_COLLECTION_V2_KEY = 'funnels:json'; // Use same key for direct migration
export const FUNNEL_VERSION = '1.0.0';
export const FUNNEL_V2_VERSION = '2.0.0';

// Re-export funnel step definitions
export {
  MUNICIPALITY_FUNNEL_STEPS,
  SOCIAL_MEDIA_FUNNEL_STEPS,
  EMAIL_FUNNEL_STEPS,
  GEWERBE_FUNNEL_STEPS,
  TEILNEHMER_FUNNEL_STEPS
} from '@/types/funnel';

// Default configurations
export const DEFAULT_MUNICIPALITY_CONFIG = {
  retention_days: 90,
  anonymization_after_days: 30,
  session_timeout_minutes: 30
};

export const DEFAULT_SOCIAL_MEDIA_CONFIG = {
  retention_days: 60,
  anonymization_after_days: 14,
  session_timeout_minutes: 15
};

export const DEFAULT_EMAIL_CONFIG = {
  retention_days: 120,
  anonymization_after_days: 45,
  session_timeout_minutes: 60
};

// Business type specific configurations
export const DEFAULT_GEMEINDEN_CONFIG = {
  retention_days: 90,
  anonymization_after_days: 30,
  session_timeout_minutes: 30
};

export const DEFAULT_GEWERBE_CONFIG = {
  retention_days: 120,
  anonymization_after_days: 45,
  session_timeout_minutes: 60
};

export const DEFAULT_TEILNEHMER_CONFIG = {
  retention_days: 90,
  anonymization_after_days: 30,
  session_timeout_minutes: 30
};